import AssetLoanApprovalTable from "./ApprovalTable";

const BranchAssetLoanApproval = () => <AssetLoanApprovalTable level="branch" />;

export default BranchAssetLoanApproval;
